import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { MbResourcesEntries } from '../../../models'

export const MB_PRODUCT_TAB_RESOURCES_NORMALIZER = new InjectionToken<Converter<any, MbResourcesEntries>>('MbProductTabResourcesNormalizer')
